import NotFoundPage from '@app/components/NotFoundPage';

function NotFoundRoute() {
  return (
    <NotFoundPage title="원하시는 페이지를 찾을 수 없습니다.">
      잘못된 주소로 접근하셨습니다.
      <br />
      경로를 확인해 주세요.
    </NotFoundPage>
  );
}

export default NotFoundRoute;
